import React, { useState } from 'react'
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CRow,
  CCol,
  CButton,
  CTooltip,
  CLink,
} from '@coreui/react-pro'
import { Link, useHistory } from 'react-router-dom'
import parse from 'html-react-parser'
import StatusBadgeRenderer from './CandidateListComponents/StatusBadgeRenderer'
import {
  CandidateListsView,
  TableProps,
} from '../../../types/Recruitment/CandidateList/CandidateListTypes'
import { reduxServices } from '../../../reducers/reduxServices'
import { useAppDispatch, useTypedSelector } from '../../../stateStore'
import OModal from '../../../components/ReusableComponent/OModal'
import OToast from '../../../components/ReusableComponent/OToast'
import OPageSizeSelectRevised from '../../../components/ReusableComponent/OPageSizeSelectRevised'
import OPaginationRevised from '../../../components/ReusableComponent/OPaginationRevised'
import usePermissionAccess from '../../../middleware/hooks/usePermissionAccess'

const CandidateListTable = ({
  pageSize,
  currentPage,
  searchInput,
  userAccess,
  searchData,
}: TableProps): JSX.Element => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const isVendor = localStorage.getItem('isVendor') === 'true'
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)
  const [deleteLocationId, setDeleteLocationId] = useState(0)
  const [deleteLocationName, setDeleteLocationName] = useState('')
  const [isJobDescriptionModalVisible, setIsJobDescriptionModalVisible] =
    useState(false)
  const [description, setDescription] = useState({} as CandidateListsView)
  const [showJobView, setShowJobView] = useState(false)
  const getAllCandidateViewDetails = useTypedSelector(
    reduxServices.candidateList.selectors.getAllCandidateViewDetails,
  )

  const CandidateListSize = useTypedSelector(
    reduxServices.candidateList.selectors.listSize,
  )
  const jobOpeningById = useTypedSelector(
    reduxServices.jobVacancies.selectors.JobOpeningById,
  )
  const getItemNumber = (index: number) => {
    return (currentPage - 1) * pageSize + index + 1
  }

  const deleteButtonHandler = (id: number, locationName: string) => {
    //candidateList/deleteCandidate/rejected
    setIsDeleteModalVisible(true)
    setDeleteLocationId(id)
    setDeleteLocationName(locationName)
  }

  const deletedToastElement = (
    <OToast
      toastColor="label-success"
      toastMessage="Candidate Deleted Successfully"
    />
  )
  const deleteFailedToastMessage = (
    <OToast
      toastMessage="You can't delete.Candidate is in progress
      "
      toastColor="label-danger"
      data-testid="failedToast"
    />
  )

  const confirmDeleteLocation = async () => {
    setIsDeleteModalVisible(false)
    const deleteLocationResult = await dispatch(
      reduxServices.candidateList.deleteCandidate(deleteLocationId),
    )

    if (
      reduxServices.candidateList.deleteCandidate.fulfilled.match(
        deleteLocationResult,
      )
    ) {
      searchData(pageSize, currentPage, { searchByMultipleFlag: searchInput })

      dispatch(reduxServices.app.actions.addToast(deletedToastElement))
      dispatch(reduxServices.app.actions.addToast(undefined))
    } else if (
      reduxServices.candidateList.deleteCandidate.rejected.match(
        deleteLocationResult,
      ) &&
      deleteLocationResult.payload === 409
    ) {
      dispatch(reduxServices.app.actions.addToast(deleteFailedToastMessage))
      dispatch(reduxServices.app.actions.addToast(undefined))
    }
  }
  const timeLineHandler = (personId: number) => {
    dispatch(reduxServices.intervieweeDetails.timeLineData(personId))
    dispatch(reduxServices.intervieweeDetails.actions.clearAPiData(''))
  }

  const handler = async (candidateId: number) => {
    const timeLineResultAction = await dispatch(
      reduxServices.intervieweeDetails.timeLineData(candidateId),
    )

    if (timeLineResultAction.payload === 403) {
      history.push('/forbidden')
    }
  }

  const permissions = usePermissionAccess()
  const userAccessTimeLine = permissions.accessibility('candidateTimeLine')

  // const jobInfoHandler = (data: CandidateListsView) => {
  //   dispatch(reduxServices.jobVacancies.getJobOpeningById(data.appliedFor.id))
  // }
  const handleViewJob = (data: CandidateListsView) => {
    dispatch(reduxServices.jobVacancies.getJobOpeningById(data.appliedFor.id))
    setShowJobView(true)
  }
  const handlePaginationConfigChange = (pageNumber: number, size: number) => {
    searchData(size, pageNumber)
  }

  const handleModal = (jobDescription: CandidateListsView) => {
    setDescription(jobDescription)
    setIsJobDescriptionModalVisible(true)
  }
  const limitChar = (jobVacancy: CandidateListsView): string => {
    if (jobVacancy?.skills === null) {
      return 'N/A'
    }
    if (jobVacancy?.skills !== '') {
      const removeTag = `${jobVacancy?.skills
        ?.replace(/<[^>]+>/g, '')
        ?.replace(/:/g, '')}`
      return removeTag && removeTag?.length > 30
        ? `${removeTag?.substring(0, 30)}...`
        : removeTag
    } else {
      return 'N/A'
    }
  }
  const getNumericInterviewRound = (status?: string): number => {
    if (!status) return 0
    const match = /^L([1-5])_SHORTLISTED$/.exec(status)
    return match ? Number(match[1]) : 0
  }

  const getInterviewRoundLabel = (status?: string): string => {
    return `L${getNumericInterviewRound(status)}`
  }
  const getInterviewRoundDisplay = (item: CandidateListsView): string => {
    const round = item?.interviewRound
    if (round !== undefined && round !== null && `${round}`.trim() !== '') {
      return `L${round}`
    }
    return getInterviewRoundLabel(item?.cadidateInterviewStatus)
  }
  return (
    <>
      <CTable striped responsive>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col" className="text-center">
              #
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-left">
              Name
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-left">
              Position Applied for
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-left">
              Job Code
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-left">
              Interview Round
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-center">
              Mobile
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-left">
              Email ID
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-center">
              Experience
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-left">
              Skills
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-left">
              Technology
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-left">
              Recruiter
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-left">
              Reference
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-left">
              Country
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-center">
              Status
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-center">
              Actions
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {getAllCandidateViewDetails?.length > 0 &&
            getAllCandidateViewDetails?.map((item, index) => {
              const newDesc = limitChar(item)
              return (
                <CTableRow key={index}>
                  <CTableDataCell scope="row" className="text-center">
                    {getItemNumber(index)}
                  </CTableDataCell>
                  <CTableDataCell
                    scope="row"
                    className="sh-organization-link text-left"
                  >
                    <Link
                      to={`/candidatetimeline/${item?.personId}`}
                      className="cursor-pointer"
                      onClick={() => handler(item?.personId)}
                    >
                      {item?.fullName}
                    </Link>
                  </CTableDataCell>
                  <CTableDataCell className="text-left">
                    {item?.appliedForVacancy}
                  </CTableDataCell>
                  <CTableDataCell
                    scope="row"
                    className="sh-organization-link sh-comment text-left"
                  >
                    <CLink
                      className="cursor-pointer text-decoration-none"
                      onClick={() => handleViewJob(item)}
                    >
                      {item.appliedFor.jobCode}
                    </CLink>
                  </CTableDataCell>
                  <CTableDataCell className="text-left">
                    {getInterviewRoundDisplay(item)}
                  </CTableDataCell>
                  <CTableDataCell className="text-center">
                    {item?.mobile}
                  </CTableDataCell>
                  <CTableDataCell className="text-left">
                    {item?.email}
                  </CTableDataCell>
                  <CTableDataCell className="text-center">
                    {item?.experience}
                  </CTableDataCell>
                  {/* <CTableDataCell className="text-left">
                    {item?.skills}
                  </CTableDataCell> */}
                  <CTableDataCell
                    scope="row"
                    className="sh-organization-link sh-comment"
                  >
                    {newDesc !== 'N/A' ? (
                      <CLink
                        className="cursor-pointer text-decoration-none"
                        data-testid={`vendor-address-${index}`}
                        onClick={() => handleModal(item)}
                      >
                        {parse(newDesc)}
                      </CLink>
                    ) : (
                      'N/A'
                    )}
                  </CTableDataCell>
                  <CTableDataCell className="text-left">
                    {item?.technology}
                  </CTableDataCell>

                  <CTableDataCell className="text-left">
                    {item?.recruiter}
                  </CTableDataCell>
                  <CTableDataCell className="text-left">
                    {item?.sourcelookUp?.sourceName}
                  </CTableDataCell>
                  <CTableDataCell className="text-left">
                    {item?.country?.name}
                  </CTableDataCell>
                  <CTableDataCell className="text-center">
                    {StatusBadgeRenderer(
                      item?.cadidateInterviewStatus,
                      isVendor,
                    )}
                  </CTableDataCell>
                  <CTableDataCell className="actions text-center">
                    {userAccess?.updateaccess && (
                      <Link to={`/editcandidate/${item?.personId}`}>
                        <CTooltip content="Edit">
                          <CButton
                            color="primary btn-ovh me-1"
                            className="btn-ovh-employee-list me-1"
                            data-testid={`btn-edit${index}`}
                          >
                            <i className="fa fa-edit" aria-hidden="true"></i>
                          </CButton>
                        </CTooltip>
                      </Link>
                    )}
                    {userAccessTimeLine?.viewaccess && (
                      <CTooltip content="Timeline">
                        <Link to={`/candidatetimeline/${item?.personId}`}>
                          <CButton
                            color="primary btn-ovh me-1"
                            className="btn-ovh-employee-list me-1"
                            data-testid={`sc-timeline-btn${index}`}
                            onClick={() => {
                              timeLineHandler(item?.personId)
                            }}
                          >
                            <i
                              className="fa fa-bar-chart"
                              aria-hidden="true"
                            ></i>
                          </CButton>
                        </Link>
                      </CTooltip>
                    )}
                    {userAccess?.deleteaccess && (
                      <CTooltip content="Delete">
                        <CButton
                          data-testid={`btn-delete${index}`}
                          size="sm"
                          color="danger btn-ovh me-1"
                          className="btn-ovh-employee-list me-1"
                          onClick={() =>
                            deleteButtonHandler(item?.personId, item?.fullName)
                          }
                        >
                          <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </CButton>
                      </CTooltip>
                    )}
                  </CTableDataCell>
                </CTableRow>
              )
            })}
        </CTableBody>
      </CTable>

      <CRow>
        <CCol lg={3} md={6}>
          <p className="mt-2">
            <strong>Total Records: {CandidateListSize}</strong>
          </p>
        </CCol>
        <CCol lg={3} md={6}>
          {CandidateListSize > 20 && (
            <OPageSizeSelectRevised
              changeCallback={handlePaginationConfigChange}
              options={[20, 40, 60, 80, 100]}
            />
          )}
        </CCol>
        {CandidateListSize > 20 && (
          <CCol
            lg={6}
            className="d-grid gap-1 d-md-flex justify-content-md-end"
          >
            <OPaginationRevised
              paginationChangeCallback={handlePaginationConfigChange}
            />
          </CCol>
        )}
      </CRow>
      <OModal
        modalSize="lg"
        alignment="center"
        modalFooterClass="d-none"
        modalHeaderClass="d-none"
        visible={isJobDescriptionModalVisible}
        setVisible={setIsJobDescriptionModalVisible}
      >
        <span className="descriptionField" data-testid="modal-cnt-add">
          <p
            dangerouslySetInnerHTML={{
              __html: description?.skills,
            }}
          />
        </span>
      </OModal>
      <OModal
        alignment="center"
        visible={isDeleteModalVisible}
        setVisible={setIsDeleteModalVisible}
        modalTitle="Delete Candidate"
        confirmButtonText="Yes"
        cancelButtonText="No"
        closeButtonClass="d-none"
        confirmButtonAction={confirmDeleteLocation}
        modalBodyClass="mt-0"
      >
        <>
          Do you really want to delete this{' '}
          <strong>{deleteLocationName}</strong> Candidate ?
        </>
      </OModal>
      <OModal
        modalSize="lg"
        alignment="center"
        modalFooterClass="d-none"
        modalHeaderClass="d-none"
        visible={showJobView}
        setVisible={setShowJobView}
      >
        <span className="descriptionField" data-testid="modal-cnt-add">
          {jobOpeningById?.description ? (
            <p
              dangerouslySetInnerHTML={{
                __html: jobOpeningById.description,
              }}
            />
          ) : (
            <p>N/A</p>
          )}
        </span>
      </OModal>
    </>
  )
}

export default CandidateListTable
